<div class="zwi-section">
  <zwi-widget>
    <mat-chip-listbox [hideSingleSelectionIndicator]="true" [multiple]="false" (change)="updateActive($event)" aria-label="Saved sermons selection">
      <mat-chip-option [highlighted]="active === 'All'" selected>All</mat-chip-option>
      <mat-chip-option [highlighted]="active === 'Ministry'">Ministry</mat-chip-option>
      <mat-chip-option [highlighted]="active === 'Verse'">Verse</mat-chip-option>
      <mat-chip-option [highlighted]="active === 'Series'">Series</mat-chip-option>
    </mat-chip-listbox>
  </zwi-widget>
  @if (getFavorites.status() !== 2 || favorites.length > 0) {
    @if (active === 'All') {
      <zwi-sermon-list [sermons]="favorites" [sortBy]="'airDate'" (starChange)="favoriteChange($event)"></zwi-sermon-list>
    }
    @if (active === 'Ministry') {
      <zwi-sermons-by-ministry [sermons]="favorites" (starChange)="favoriteChange($event)"></zwi-sermons-by-ministry>
    }
    @if (active === 'Verse') {
      <zwi-verse-sermons [sermons]="favorites" (starChange)="favoriteChange($event)"></zwi-verse-sermons>
    }
    @if (active === 'Series') {
      <zwi-series-sermons [sermons]="favorites" (starChange)="favoriteChange($event)"></zwi-series-sermons>
    }
  } @else {
    <zwi-call-to-action>
      <ng-container title>You have not saved any sermons yet.</ng-container>
      <ng-container content>This screen will be replaced when you save sermons.</ng-container>
    </zwi-call-to-action>
  }
</div>
